/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemFieldDtoSchema = z.object({
  name: z.string(),
  projectable: z.boolean(),
  sortable: z.boolean(),
});
